import React, { useState, useEffect, useRef } from "react";
import { useSelector } from "react-redux";
import { Paper } from "@material-ui/core";
import { baseUrl } from "../../../services/config";
import { Table, Modal, Spinner } from "react-bootstrap";
import { toAbsoluteUrl } from "../../../_metronic/_helpers";
import SVG from "react-inlinesvg";
import ReactToPrint from "react-to-print";
import "./myprint.css";
import "../../../components/PrintChallanModal/printChallan.style.css";
import MultiStudentFeeChallan from "../MultiStudentFeeChallan/MultiStudentFeeChallan";
import { useAlert } from "react-alert";

const StudentWisePrint = () => {
  const componentRef = useRef(null);
  const componentRef1 = useRef(null);
  const onBeforeGetContentResolve = React.useRef(null);
  const authtoken = localStorage.getItem("userToken");
  const user = useSelector((state) => state.user.user);
  const [viewModal, setviewModal] = useState(false);
  const [loading, setloading] = useState(false);
  const [campuses, setallcampuses] = useState(user.campuses || []);

  const [campusCourseData, setCampusCourseData] = useState([]);
  const [courseClassData, setCourseClassData] = useState([]);
  const [classSectionData, setClassSectionData] = useState([]);

  const [campusId, setCampusId] = useState("");
  const [courseId, setCourseId] = useState("");
  const [classId, setClassId] = useState("");
  const [sectionId, setSectionId] = useState("");

  const [selectedStudentChallan, setselectedStudentChallan] = useState([]);
  const [searchtext, setsearchtext] = useState("");
  const [allstudentList, setallstudentsList] = useState([]);
  const [printloading, setprintloading] = React.useState(false);
  const [text, setText] = React.useState("old boring text");
  const [allsessions, setallsessions] = useState([]);
  const [currentSession, setCurrentSession] = useState("");

  const [blankPage, setBlankPage] = useState(false);
  const [showResult, setShowResult] = useState(false);
  const alert = useAlert();
  const pageStyle = `
  @page {
    size:letter landscape !important;
  }
  `;
  const [selectedStudents, setSelectedStudents] = useState([]);
  const [mainCheckBoxChecked, setmaincheckboxChecked] = useState(false);
  const searchClicked = useRef(false);
  const firstTimeLoad = useRef(false);

  useEffect(() => {
    if (!firstTimeLoad.current) {
      firstTimeLoad.current = true;
      getAllSessions();
    }

    if (searchClicked.current) {
      searchClicked.current = false;
      setAllCheckboxes(true);
    } else {
      checkAllCheckBoxes();
    }
  }, [[], selectedStudents]);

  const getMonthName = (date) => {
    if (date == "") {
      return "_";
    }
    const monthNames = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];
    const d = new Date(date);

    return `${monthNames[d.getMonth()]}`;
  };

  const getAllSessions = () => {
    fetch(`${baseUrl}/session`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${authtoken}`,
      },
    })
      .then((res) => res.json())
      .then((data) => {
        setallsessions(data.payload);
        data.payload.forEach((session, index) => {
          if (session.active_academic_year == "1") {
            setCurrentSession(session.id);
          }
        });
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const onCampusChange = (id) => {
    setCampusId(id);
    getCampusCourses(id);
  };

  const getCampusCourses = (id) => {
    if (id == "") {
      return alert.error("Please Select Campus");
    }

    fetch(`${baseUrl}/campus-all-courses/${id}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${authtoken}`,
      },
    })
      .then((res) => {
        res.json().then((data) => {
          setCampusCourseData(data.payload);
        });
      })
      .catch((err) => {
        alert.error(err);
      });
  };

  const onCourseChange = (id) => {
    setCourseId(id);
    getCourseClasses(id);
  };

  const getCourseClasses = (id) => {
    if (id == "") {
      return alert.error("Please Select Course");
    }
    fetch(`${baseUrl}/course-all-classes/${id}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${authtoken}`,
      },
    })
      .then((res) => {
        res.json().then((data) => {
          setCourseClassData(data.payload);
        });
      })
      .catch((err) => {
        alert.error(err);
      });
  };

  const onClassChange = (id) => {
    setClassId(id);
    getSectionsList(id);
  };

  const getSectionsList = (id) => {
    if (id == "" || campusId == "" || courseId == "") {
      alert.error("Please Select Campus / Course/ Class");
      return;
    }
    fetch(`${baseUrl}/class-section/${campusId}/${courseId}/${id}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${authtoken}`,
      },
    })
      .then((res) => {
        res.json().then((data) => {
          setClassSectionData(data.payload);
        });
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const getChallans = () => {
    if (currentSession == "") {
      alert.error("Please Select Session");
      return;
    }

    if (campusId == "") {
      alert.error("Please Select Campus");
      return;
    }

    if (courseId == "") {
      alert.error("Please Select Course");
      return;
    }

    if (classId == "") {
      alert.error("Please Select Class");
      return;
    }

    if (sectionId == "") {
      alert.error("Please Select Section");
      return;
    }
    setloading(true);

    const data = {
      year_id: currentSession,
      campus_id: campusId,
      course_id: courseId,
      student_class_id: classId,
      global_section_id: sectionId,
    };

    fetch(`${baseUrl}/unpaid_challan_combine`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${authtoken}`,
      },
      body: JSON.stringify(data),
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.metadata.success) {
          if (data.payload.students.length == 0) {
            alert.error("Student Record Not Found");
            setSelectedStudents([]);
            setloading(false);
            return;
          }
          searchClicked.current = true;
          setallstudentsList(data.payload.students);
          setloading(false);
          setShowResult(true);
          // setAllCheckboxes(true);
        }
      })
      .catch((err) => {
        setloading(false);

        console.log(err);
      });
  };

  const addFine = () => {
    if (selectedStudents == "") {
      alert.error("Please Select Some Challans");
      return;
    }
    let selected_student = selectedStudents.map((item, index) =>
      String(item.id)
    );
    setloading(true);

    const data = {
      student_ids: selected_student,
    };

    fetch(`${baseUrl}/add-fine`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${authtoken}`,
      },
      body: JSON.stringify(data),
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.metadata.success) {
          if (data.payload.length == 0) {
            alert.error("Fine Not Generated");
            setSelectedStudents([]);
            setloading(false);
            return;
          }
          searchClicked.current = true;
          alert.success(data.payload);
          setloading(false);
        } else if (!data.metadata.success) {
          Object.values(data.metadata.message).map((msg) => {
            alert.error(msg);
          });
          setSelectedStudents([]);
          setloading(false);
        } else {
          alert.show("Something Went Wrong");
          setSelectedStudents([]);
          setloading(false);
        }
      })
      .catch((err) => {
        setloading(false);

        console.log(err);
      });
  };

  const getFeeAmount = (challans) => {
    let sum = 0;
    challans.forEach((element) => {
      sum += parseInt(element.amount);
    });
    return sum;
  };

  const gotoviewpage = (student) => {
    setselectedStudentChallan(student.fee_challans_detials);
    setviewModal(true);
  };

  const handleAfterPrint = React.useCallback(() => {}, []);

  const handleBeforePrint = React.useCallback(() => {}, []);

  const handleOnBeforeGetContent = React.useCallback(() => {
    setprintloading(true);
    setText("Loading new text...");

    return new Promise((resolve) => {
      onBeforeGetContentResolve.current = resolve;

      setTimeout(() => {
        setprintloading(false);
        setText("New, Updated Text!");
        resolve();
      }, 2000);
    });
  }, [setprintloading, setText]);

  const searchbyRegId = () => {
    if (searchtext == "") {
      alert.error("Please enter Admission Id or Name");
    } else {
      const data = {
        search_keyword: searchtext.toLocaleUpperCase(),
      };
      setloading(true);

      fetch(`${baseUrl}/unpaid_challan_search_std_wise`, {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${authtoken}`,
        },

        body: JSON.stringify(data),
      })
        .then((res) => res.json())
        .then((data) => {
          if (data.metadata.success) {
            if (data.payload.students.length == 0) {
              alert.error("Student Record Not Found");
              setSelectedStudents([]);
              setloading(false);
              return;
            }
            searchClicked.current = true;
            setallstudentsList(data.payload.students);
            setloading(false);
            setShowResult(true);
          } else if (!data.metadata.success) {
            Object.values(data.metadata.message).map((msg) => {
              alert.error(msg[0]);
            });
          }
        })
        .catch((err) => {
          console.log("err is re", err);
        });
    }
  };

  const handleMainCheckboxClick = () => {
    if (mainCheckBoxChecked) setAllCheckboxes(false);
    else setAllCheckboxes(true);
  };

  const setAllCheckboxes = (value) => {
    setmaincheckboxChecked(value);
    if (value) {
      setSelectedStudents([]);
    }

    allstudentList.map((item, i) => {
      item.checked = value;
      if (!value) {
        RemoveSelectedChallan(item);
      } else {
        AddSelectedChallan(item);
      }
    });
  };

  const checkAllCheckBoxes = () => {
    if (allstudentList.length == selectedStudents.length) {
      setmaincheckboxChecked(true);
    } else if (mainCheckBoxChecked) {
      setmaincheckboxChecked(false);
    }
  };

  const handleChallansCheckBoxClick = (e, index) => {
    allstudentList.map((item, i) => {
      if (item.id == index) {
        item.checked = !item.checked;

        if (item.checked) {
          AddSelectedChallan(item);
        } else {
          RemoveSelectedChallan(item);
        }
      }
    });
  };

  const AddSelectedChallan = (item) => {
    setSelectedStudents((prevSelectedChallans) => [
      ...prevSelectedChallans,
      item,
    ]);
  };

  const RemoveSelectedChallan = (item) => {
    setSelectedStudents((prevSelectedChallans) =>
      prevSelectedChallans.filter((std) => std.id !== item.id)
    );
  };

  return (
    <div>
      <Paper
        style={{ marginTop: "10px", marginBottom: "10px", padding: "15px" }}
      >
        <div className="row mt-3">
          <div className="col-md-3">
            <label>
              <b>Select Session</b> <span style={{ color: "red" }}>*</span>
            </label>
            <select
              onChange={(e) => setCurrentSession(e.target.value)}
              className="form-select"
              style={{ height: 40 }}
              value={currentSession}
              aria-label="Default select example"
            >
              <option value="">Select Session</option>
              {allsessions.map((session, index) => (
                <option key={index} value={session.id}>
                  {session.year}
                </option>
              ))}
            </select>
          </div>

          <div className="col-md-3">
            <label>
              <b>Select Campus </b> <span style={{ color: "red" }}>*</span>
            </label>
            <select
              onChange={(e) => onCampusChange(e.target.value)}
              className="form-select"
              style={{ backgroundColor: "white", height: 40 }}
              value={campusId}
              aria-label="Default select example"
            >
              <option value="">Select Campus</option>

              {campuses.map((campus, index) => (
                <option key={index} value={campus.id}>
                  {campus.name}
                </option>
              ))}
            </select>
          </div>

          <div className="col-md-3">
            <label>
              <b>Select Course </b> <span style={{ color: "red" }}>*</span>
            </label>
            <select
              className="form-select form-control"
              name="course_id"
              value={courseId}
              onChange={(e) => onCourseChange(e.target.value)}
              style={{ backgroundColor: "white", height: 40 }}
              aria-label="Default select example"
            >
              <option value="">Select Course</option>
              {campusCourseData.map((item, index) => (
                <option key={index} value={item.course?.id}>
                  {item.course?.name}
                </option>
              ))}
            </select>
          </div>

          <div className="col-md-3">
            <label>
              <b>Select Class </b> <span style={{ color: "red" }}>*</span>
            </label>
            <select
              className="form-select form-control"
              name="class_id"
              value={classId}
              onChange={(e) => onClassChange(e.target.value)}
              style={{ backgroundColor: "white", height: 40 }}
              aria-label="Default select example"
            >
              <option value="">Select Class</option>
              {courseClassData.map((item, index) => (
                <option key={index} value={item.class?.id}>
                  {item.class?.name}
                </option>
              ))}
            </select>
          </div>

          <div className="col-md-3 mt-3">
            <label>
              <b>Select Section </b> <span style={{ color: "red" }}>*</span>
            </label>
            <select
              className="form-select form-control"
              name="section_id"
              value={sectionId}
              onChange={(e) => setSectionId(e.target.value)}
              style={{ backgroundColor: "white" }}
              aria-label="Default select example"
            >
              <option value="">Select Section</option>
              {classSectionData.map((item, index) => (
                <option key={index} value={item.section?.id}>
                  {item.section?.name}
                </option>
              ))}
            </select>
          </div>

          <div className=" d-flex col-md-8 mt-11">
            <button
              type={"submit"}
              onClick={getChallans}
              className="btn btn-primary mr-4"
            >
              Get Fee Challan
            </button>

            {showResult && allstudentList.length > 0 ? (
              <>
                <ReactToPrint
                  pageStyle={pageStyle}
                  documentTitle="Challan Copy"
                  onAfterPrint={handleAfterPrint}
                  onBeforeGetContent={handleOnBeforeGetContent}
                  onBeforePrint={handleBeforePrint}
                  removeAfterPrint={true}
                  trigger={() => (
                    <button
                      disabled={printloading ? true : false}
                      className="btn btn-primary mx-2"
                    >
                      {printloading ? "Printing..." : "Print Fee Challan"}
                    </button>
                  )}
                  content={() => componentRef.current}
                />

                <button
                  type="button"
                  onClick={addFine}
                  className="btn btn-primary mx-2"
                >
                  Add Fine
                </button>
              </>
            ) : null}

            <div className="col-md-4 mt-4">
              <label className="checkbox checkbox-single">
                <input
                  type="checkbox"
                  onChange={(e) => setBlankPage(e.target.checked)}
                />
                <span />
                &nbsp;&nbsp;&nbsp;Use Blank Page For Print
              </label>
            </div>
          </div>

          <div className="row mt-5">
            <div style={{ margin: "1px" }} className="col-md-4">
              <input
                onChange={(e) => setsearchtext(e.target.value)}
                className="form-control"
                placeholder="Enter Name or Admission ID"
              />
            </div>
            <div className="col-md-4">
              <button onClick={searchbyRegId} className="btn btn-primary">
                Search
              </button>
            </div>
          </div>
        </div>

        <Table responsive>
          <thead>
            <tr id="tbl">
              <th style={{ width: "5px" }}>
                <input
                  onClick={(e) => {
                    handleMainCheckboxClick();
                  }}
                  checked={mainCheckBoxChecked}
                  placeholder="Checkbox"
                  type="checkbox"
                  readOnly
                />
              </th>
              <th>Admission ID</th>
              <th>Student Name</th>
              <th>Father Name</th>
              <th>Class Section</th>
              <th>Amount</th>
              <th>Fee Month</th>
              <th>View</th>
              {/* <th>Print</th> */}
            </tr>
          </thead>
          <tbody>
            {allstudentList &&
              allstudentList.map((student, index) => (
                <tr key={index}>
                  <td style={{ width: "5px" }}>
                    <input
                      type="checkbox"
                      value={student.id}
                      key={student.id}
                      onClick={(e) => {
                        handleChallansCheckBoxClick(e, student.id);
                      }}
                      checked={student.checked ?? false}
                      style={{ border: "10px" }}
                      readOnly
                    ></input>
                  </td>
                  <td className="text_align_start ">{student.admission_id}</td>
                  {student.status == 2 ? (
                    <td className="text_align_start ">{student.name}</td>
                  ) : (
                    <td className="text_align_start" style={{ color: "red" }}>
                      {student.name}
                    </td>
                  )}
                  <td className="text_align_start ">{student.father_name}</td>
                  <td style={{ textAlign: "start" }}>
                    {student.student_class.name}&nbsp;
                    {student.global_section.name}&nbsp; ({student.campus.name})
                  </td>
                  <td className="text_align_start ">
                    {getFeeAmount(student?.fee_challans_detials)}
                  </td>
                  <td className="text_align_start ">
                    {student?.fee_challans_detials.map(
                      (student_fee_months, index) => (
                        <React.Fragment key={index}>
                          {getMonthName(student_fee_months?.fee_month)}
                          {index < student?.fee_challans_detials.length - 1 &&
                            ","}
                          &nbsp;
                        </React.Fragment>
                      )
                    )}
                  </td>
                  <td className="text_align_start">
                    <a
                      className="btn btn-icon btn-light btn-hover-primary btn-sm "
                      onClick={() => gotoviewpage(student)}
                    >
                      <span className="svg-icon text_align_start svg-icon-md svg-icon-danger">
                        <SVG
                          src={toAbsoluteUrl(
                            "/media/svg/icons/Devices/Display2.svg"
                          )}
                        />
                      </span>
                    </a>
                  </td>
                </tr>
              ))}
          </tbody>
        </Table>

        {loading ? (
          <div className="row justify-content-center">
            <Spinner
              className="text-center"
              variant="info"
              animation="border"
            />
          </div>
        ) : null}
      </Paper>

      <Modal show={viewModal}>
        <Modal.Header>
          <Modal.Title>Fee Challan Details</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Table responsive>
            <thead>
              <tr id="tbl">
                <th>Fee Challan Id</th>
                <th>Fee Month</th>
                <th>Fee Name</th>
                <th>Amount</th>
              </tr>
            </thead>
            <tbody>
              {selectedStudentChallan &&
                selectedStudentChallan.map((feec, index) => (
                  <tr key={index}>
                    <td className="text_align_start ">{feec.fee_challan_id}</td>

                    <td className="text_align_start ">{feec.fee_month}</td>
                    <td className="text_align_start ">{feec.fee_name}</td>
                    <td className="text_align_start ">{feec.amount}</td>
                  </tr>
                ))}
            </tbody>
          </Table>
        </Modal.Body>

        <Modal.Footer>
          <button
            onClick={() => setviewModal(false)}
            className="btn btn-danger"
          >
            Close
          </button>
        </Modal.Footer>
      </Modal>

      {/* ///////////////////////////////print/////////////////////////////////////////////////// */}
      <div ref={componentRef} id="printSection" className="customTablePrint">
        <MultiStudentFeeChallan
          allstudentList={
            allstudentList.length == selectedStudents.length
              ? allstudentList
              : selectedStudents
          }
          blankPage={blankPage}
        />
      </div>
    </div>
  );
};

export default StudentWisePrint;
